module.exports = __webpack_public_path__ + "1536b3d3421a8528bcd35d4358fd16c2.jpg";